import { createIcon } from '@chakra-ui/react';
// using `path`
export const SharedIconSearch = createIcon({
  displayName: 'SharedIconSearch',
  viewBox: '0 0 24 24',
  // path can also be an array of elements, if you have multiple paths, lines, shapes, etc.
  path: [
    <path
      d="M17.6407499,15.9409466 C18.9962225,14.213192 19.7383694,12.1000851 19.7383694,9.86935238 C19.7383694,1.07371265 9.06443323,-3.28104867 2.8929063,2.89116053 C-0.963609474,6.74792141 -0.964914114,12.9904934 2.8926647,16.8477375 C6.47264511,20.4276382 12.0747692,20.6748745 15.9417704,17.6405755 L22.3008756,24 L24,22.3008061 L17.6407499,15.9409466 Z M9.87060409,17.3349613 C3.19543781,17.3349613 -0.0663554098,9.24899027 4.59232067,4.59049943 C9.29786714,-0.116075876 17.3351742,3.26965053 17.3351742,9.86930406 C17.3351742,13.9939848 13.9969387,17.3349613 9.87060409,17.3349613 Z"
      fill="currentColor"></path>
  ]
});
